import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Flex, Form, Typography } from 'antd';
import { maxWidth } from 'config/constants';

export const StyledIssueDetails = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: white;
    max-width: ${kcc.screen.CONTENT_MAX_WIDTH}px;

    .ant-select,
    .ant-select-single {
      height: auto;
    }

    .issue-details__select-phone-code {
      width: 140px;
      margin-right: 8px;

      .ant-select-selector {
        height: 48px !important;
        padding: 8px 12px !important;
      }
    }

    .issue-details__select-label {
      display: flex;
      align-items: center;

      p {
        margin: 0;
      }
    }

    ${maxWidth.m} {
      align-items: flex-start;

      .issue-details__back-btn,
      .issue-details__review-btn {
        width: 172px;
        font-size: ${kcc.typography.FONT_SIZE.XL}px;
      }
    }

    .issue-details__back-btn {
      padding: 0;

      &:hover {
        background: transparent !important;
      }
    }

    .ant-btn-icon {
      line-height: 15px;

      svg {
        width: 20px;
        height: 20px;
      }
    }
  `}
`;

export const StyledIssueDetailsFormItem = styled(Form.Item)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    .ant-form-item-label > label {
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    }

    .ant-form-item-optional {
      font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
    }

    .ant-form-item-explain-error {
      padding: ${kcc.padding.CONTENT_VERTICAL_SM}px;
    }

    label.ant-form-item-required-mark-optional {
      flex-wrap: wrap;
    }

    .ant-form-item-extra {
      font-size: ${kcc.typography.FONT_SIZE.BASE}px;
      margin-left: ${kcc.spacing.XS};
      margin-top: 2px;
      line-height: 20px;
      min-height: fit-content;
    }

    input::placeholder {
      color: ${kcc.colors.TEXT_PLACEHOLDER};
    }

    .ant-input-status-success {
      border-color: ${kcc.colors.TEXT};
    }

    .ant-input:not([value='']),
    [value]:not([value='']) {
      border-color: ${kcc.colors.TEXT};
    }

    &.issue-details__form-item-border-less {
      .ant-form-item-control-input {
        min-height: auto;
      }
    }

    .ant-checkbox .ant-checkbox-inner {
      border-radius: 0px;
    }

    .country-code-validated {
      .ant-select-selector {
        border-color: black !important;
      }
    }

    &.issue-details__form-item-contact-person {
      .ant-form-item-control-input {
        min-height: fit-content;
      }
    }
  `}
`;

export const StyledFormSubTitle = styled(Typography.Title)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BLACK} !important;
    text-transform: uppercase;
    font-size: ${kcc.typography.FONT_SIZE.XL}px;
    letter-spacing: 0.36px;
    margin-bottom: ${kcc.spacing.LG} !important;
  `}
`;
